// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__xHJi0","title__text":"PageTitle_title__text__P2G8c","title__icon":"PageTitle_title__icon__slL32"};